/**
 * CRM Chat Routes
 * 
 * Configuración de rutas para el módulo de chat CRM.
 * Ruta principal: /erp/chat (siguiendo el patrón de otros módulos CRM como customers)
 */

import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';
import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';

const ChatPage = lazyWithRetry(() => import('../pages/ChatPage.tsx'));

const chatPageNode = {
    component: ChatPage,
} satisfies ComponentPage;

const crmChatRoutes: ComponentOrMapping = {
    crm: {
        chat: chatPageNode,
    },
};

export default crmChatRoutes;

